/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BasePOCOMongoEntity } from './basePOCOMongoEntity';
import { EntityStatus } from './entityStatus';


export interface FeedbackMessage extends BasePOCOMongoEntity { 
    id: string;
    feedbackId?: number;
    message?: string;
    dayOfWeek?: number;
}
